/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIArticleProperty
 */
export interface APIArticleProperty {
    /**
     * 
     * @type {string}
     * @memberof APIArticleProperty
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleProperty
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleProperty
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleProperty
     */
    type?: string;
}

/**
 * Check if a given object implements the APIArticleProperty interface.
 */
export function instanceOfAPIArticleProperty(value: object): value is APIArticleProperty {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIArticlePropertyFromJSON(json: any): APIArticleProperty {
    return APIArticlePropertyFromJSONTyped(json, false);
}

export function APIArticlePropertyFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIArticleProperty {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'value': json['value'] == null ? undefined : json['value'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function APIArticlePropertyToJSON(value?: APIArticleProperty | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'value': value['value'],
        'type': value['type'],
    };
}

